export const FEE_PERCENTAGE = 0.02; // 2%

export const calculateFeeAmount = (amount: number): number => {
  return amount * FEE_PERCENTAGE;
};

export const calculateTotalWithFees = (amount: number): number => {
  const feeAmount = calculateFeeAmount(amount);
  return amount + feeAmount;
};